<template>
    <div class="exhibition">
        <!-- <div class="top-wr">
              <router-link to="/exhibition-detail?type=1"> <img src="@/assets/imgs/14@2x.png" alt=""></router-link>
              <router-link to="/exhibition-detail?type=2"> <img src="@/assets/imgs/13@2x.png" alt=""></router-link>
        </div>
        <div class="flex content-1">
            <div class="content-1-left">
                <img src="@/assets/imgs/zl/ex-title.png" alt="">
            </div>
            <div class="content-1-center">
                <h4>顺昌历史文化陈列展</h4>
                <div class="content-1-center-i">
                    <label>东侧二层固定展厅</label>
                </div>
                <p>
                    展厅通过大圣文化的溯源、传承、交流、弘扬四个部分，诉说大圣文化的古往今来，带领观众朋友穿越时空，探索大圣文化的传承与发展，以及与现实相适应的时代精神，顺昌大圣文化发展至今，已成为新时代中华优秀传统文化创造性转化和创新性发展的生动案例。
                </p>
            </div>
            <div class="content-1-right"><img src="@/assets/imgs/z1.jpg" alt=""></div>
        </div>
        <div class="con-box pr">
            <img class="bg-icon-1" src="@/assets/imgs/12@2x.png" alt="">
            <img class="bg-icon-2" src="@/assets/imgs/bg-icon2.png" alt="">
            <img class="bg-icon-3" src="@/assets/imgs/bg-icon3.png" alt="">
            <div class="flex content-2 container">
                <div class="content-2-left mr69">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                </div>
                <div class="content-2-right">
                    <h4>大圣文化主题展</h4>
                    <div class="content-2-right-i">
                        <label>东侧二层固定展厅</label>
                    </div>
                    <p>
                        展厅通过大圣文化的溯源、传承、交流、弘扬四个部分，诉说大圣文化的古往今来，带领观众朋友穿越时空，探索大圣文化的传承与发展，以及与现实相适应的时代精神，顺昌大圣文化发展至今，已成为新时代中华优秀传统文化创造性转化和创新性发展的生动案例。
                    </p>
                </div>
            </div>
            <div class="flex content-2 container">
                <div class="content-2-right mr135">
                    <h4 class="color1">顺昌历史文化陈列展</h4>
                    <div class="content-2-right-i ">
                        <label class="color1">东侧二层固定展厅</label>
                    </div>
                    <p class="color1">
                        闽台自古就有“山尊大圣、海祭妈祖”的传统民俗。
                        大圣文化是古闽越及早期汉民族自然崇拜的历史遗
                        存，是中华优秀传统文化和闽人智慧的代表性内容。
                        在融合中国释道文化的过程中，逐渐形成了独具特色
                        的文化内涵。在顺昌，大圣文化可追溯至唐末五代，
                        鼎盛于元明，至今已有千年历史。县域遍布宋元明清
                        各时期大圣文化遗迹，目前，已发现祭坛、神位碑刻
                        及庙堂120余处。其中，以“通天大圣”冠名登记在
                        册的祭坛及祭坛遗址78处。
                        展览精选30处冠名“通天大圣”代表性坛庙。作为大
                        圣祖地实物佐证，通过照片及简介形式进行展示，旨
                        在传承和发扬大圣祖地文化时代精神内涵，绘就两岸
                        大圣文化学术交流与民问往来新画卷
                    </p>
                </div>
                 <div class="content-2-left">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                </div>
            </div>
              <div class="flex content-2 container">
                <div class="content-2-left mr69">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                </div>
                <div class="content-2-right">
                    <h4 class="color2">合掌岩捐赠书画作品展</h4>
                    <div class="content-2-right-i">
                        <label class="color2">东侧二层固定展厅</label>
                    </div>
                    <p  class="color2">
                        展览包含顺昌著名乡贤、中国书法家协会副主席叶培贵，国家一级美术师及丽霞、李瑞峰、张仕森、徐岩、曾文田等诸多国内书画名家作品。展览作品题材丰富、风格多样，涵盖了山水、花鸟、人物等画作以及行、楷等书法作品，具有较高的艺术价值。
                    </p>
                </div>
            </div>
             <div class="flex content-2 container">
                <div class="content-2-right mr135">
                    <h4 class="color3">邂逅闽地风华<br/>
                        ——跟着诗词游福建</h4>
                    <div class="content-2-right-i ">
                        <label class="color3">东侧二层固定展厅</label>
                    </div>
                    <p class="color3">
                        “跟着诗词游福建”展览分为九个部分，各部分均以诗词为开篇，结合文物标本，介绍了省内独具特色的历史底蕴和人文气象。具体内容涵盖福州的西湖、三坊七巷、鼓山、罗星塔；厦门的鼓浪屿、金榜山；莆田的湄洲岛、木兰溪；泉州的洛阳桥、九日山、德化窑；漳州的东山岛、月港；龙岩的上杭、土楼；三明的万寿岩、宁化；南平的武夷山、北苑御茶园；宁德的霞浦、木拱廊桥等等。每一处风景都在诗词中被赋予了独特的灵魂。
                    </p>
                </div>
                 <div class="content-2-left">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                    <img src="@/assets/imgs/z1.jpg" alt="">
                </div>
            </div>

        </div> -->
        <div class="ex-title">固定展览</div>
        <div class="new-article-box">
            <div class="new-article-item"
                 @click="handleNewArticle(item.id)"
                 v-for="item in list1"
                 :key="item.id">
                <img :src="item.cover" alt="">
                <div class="new-article-item-text">
                    {{ item.title }}
                </div>
                <div class="new-article-item-sub-text">
                    {{ item.hallTitle }}
                </div>
            </div>
        </div>
        <div class="ex-title" >临时展览</div>
        <div class="new-article-box">
            <div class="new-article-item"
                 @click="handleNewArticle('extra')">
                <img src="/image/lbui.png" alt="">
                <div class="new-article-item-text">
                    顺昌大圣文化历史遗存图片展
                </div>
                <div class="new-article-item-sub-text">
                    一楼大厅环形通道
                </div>
            </div>
            <div class="new-article-item"
                 @click="handleNewArticle(item.id)"
                 v-for="item in list2"
                 :key="item.id">
                <img :src="item.cover" alt="">
                <div class="new-article-item-text">
                    {{ item.title }}
                </div>
                <div class="new-article-item-sub-text">
                    {{ item.hallTitle }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { exhibitLists } from '@/api/index';

const router = useRouter();
const handleNewArticle = (type) => {
    if (type === 'extra') {
        router.push('/exhibition-extra');
        return;
    }
    router.push('/new-article-details?type=' + type);
};
const list1 = ref([]);
const list2 = ref([]);
const getLists = () => {
    exhibitLists({
        pageNo: 1,
        pageSize: 10,
        type: 1
    }).then(({ data }) => {
        list1.value = data.list;
    });
    exhibitLists({
        pageNo: 1,
        pageSize: 10,
        type: 2
    }).then(({ data }) => {
        list2.value = data.list;
    });
};
onMounted(() => {
    getLists();
});
</script>

<style lang="scss" scoped>
.exhibition{
    font-family: sy-font, serif;
    background: #fff;
    padding-bottom: 100px;
    .top-wr{
        display: flex;
        gap: 32px;
        align-content: center;
        justify-content: center;
        padding: 40px 0;

        img{
            width: 844px;
        }
    }
    .con-box{
        box-sizing: border-box;
        background: #dfd5cc;
        padding: 0 40px 0 129px;
        overflow: hidden;

        .bg-icon-1{
            position: absolute;
            top: 20%;
            left: 0;
            width: 314px;
            height: 415px;
            opacity: 0.4;
        }
        .bg-icon-2{
            position: absolute;
            top: 70%;
            left: -30px;
            width: 408px;
            height: 441px;
            opacity: 0.4;
        }
        .bg-icon-3{
            position: absolute;
            top: 10%;
            right: -140px;
            width: 402px;
            opacity: 0.4;
        }

    }
    .banner1{
        width: 100%;
        margin-top: -45px;
    }
    .ex-title {
        color:#262626;
        font-size:32px;
        margin-top: 1px;
        font-family: sy-font, serif;
        padding: 40px 140px;
    }
    .new-article-box {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 68px;
        text-align: left;
        padding: 0 140px;
        .new-article-item {
            cursor: pointer;
            img {
                width: 100%;
        }
    }
    .new-article-item-text {
        font-weight:700;
        color:#262626;
        font-size:30px;
        margin-top: 1px;
    }
    .new-article-item-sub-text {
        font-weight:700;
        color:rgba(38, 38, 38, 0.522);
        font-size:18px;
        margin-top: 3px;
    }
}
}
.content-1{
    display: flex;
    align-items: center;
    justify-content: center;
    background: #b0d2ce;
    padding: 47px 0;
    .content-1-left{
        width: 225px;
        img{
            width: 100%;
            height: 387px;
        }
    }
    .content-1-center{
        // flex: 1;
        margin-left: 111px;
        margin-right: 40px;
        h4{
           color:#2f6d85;
            font-size:36px;
            margin-bottom: 15px;
            text-align: right;
        }
        &-i{
            text-align: right;
            margin-bottom: 30px;
        }
        label{
            font-size: 26px;
            color: #ffffff;
            background:#2f6d85;
            margin-bottom: 38px;
            padding: 7px 16px;
            text-align: right;
        }
        p{
            font-size: 20px;
            color:#377588;
            font-size:20px;
            border-top: 1px solid rgba(#2f6d85,0.3);
            padding-top: 15px;
            width:456px;
        }
    }
    .content-1-right{
        img{
            width:384px;
            height: 517px;
        }
    }
}
.mr69{
    margin-right: 69px;
}
.mr135{
    margin-right: 135px;
}
.content-2{
    padding: 63px 0 0 0;
    &-left{
        img{
           width: 595px;
           height: 371px;
           margin-bottom: 17px;
        }
    }
    &-right{
        h4{
            font-weight:700;
            color:#802920;
            font-size:36px;
            text-align: right;
             margin-bottom: 15px;
             &.color1{
                color: #226967 !important;
             }
             &.color2{
                color: #3e978e !important;
             }
             &.color3{
                color: #754c1c !important;
             }
        }
         &-i{
            text-align: right;
            margin-bottom: 30px;
        }
        label{
            font-size: 26px;
            color: #ffffff;
            background: #802920;
            margin-bottom: 38px;
            padding: 7px 16px;
            text-align: right;

            &.color1{
                background: #226967 !important;
             }
            &.color2{
                background: #3e978e !important;
             }
            &.color3{
                background: #754c1c !important;
             }
        }
        p{
            color:#802920;
            font-size:20px;
            border-top: 1px solid rgba(#2f6d85,0.3);
            padding-top: 15px;
            width:456px;
            line-height: 40px;
            &.color1{
                color: #226967 !important;
             }
            &.color2{
                color: #3e978e !important;
             }
            &.color3{
                color: #754c1c !important;
             }
        }
    }
}
</style>
